module.exports = __webpack_public_path__ + "img/james-penington.1cf62c38.png";